module.exports = __webpack_public_path__ + "static/media/header-background.df31c40f.png";